module.exports = __webpack_public_path__ + "img/innovatty_activity_offline.b42280a6.png";